import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const WellnessPromotionBackgroundBottom = forwardRef<
SVGSVGElement,
SvgIconProps
>(function WellnessPromotionBackgroundBottom(props, ref) {
  return (
    <SvgIcon ref={ref} {...props}>
      <path d="M 24.011 0 L 24.011 13.723 C 18.834 10.106 15.814 10.792 11.082 12.079 C 6.555 13.312 2.277 12.423 0 10.33 L 0 0 L 24.011 0 Z" />
    </SvgIcon>
  )
})

export default WellnessPromotionBackgroundBottom
